import React from 'react';
import { Sec, SH } from '../components/Section';
import { C } from '../constants';
import { useTheme } from '../contexts/ThemeContext';
import { TestimonialsSection } from '../components/TestimonialsSection';

export const TestimonialsWidget = () => {
  const { theme } = useTheme();

  // Exact original testimonials content
  const testimonials = [
    {
      quote: "Very detailed and well researched. Highlighted specific missing pieces and areas of improvement. Highly recommend.",
      name: "MB",
      role: "Founder"
    },
    {
      quote: "The DecX Score was eye-opening. I was burying my traction on slide 9. Fixed it. Closed my round in 3 weeks.",
      name: "Alex K",
      role: "Seed Stage"
    },
    {
      quote: "Close rate went from 12% to 28% in one quarter. The outreach sequences alone were worth it.",
      name: "Sarah M",
      role: "Sales Lead"
    },
    {
      quote: "Finally understood why leadership kept asking for more data. Shortened approval cycle by 50%.",
      name: "David L",
      role: "Product Lead"
    },
    {
      quote: "The battle cards were game-changing. We now win 3x more competitive deals.",
      name: "Mike R",
      role: "VP Sales"
    },
    {
      quote: "Got 12 investor meetings in 2 weeks using the outreach sequences. Incredible ROI.",
      name: "Priya S",
      role: "Founder"
    }
  ];

  return (
    <Sec id="testimonials" dark={theme === 'light'}>
      <div style={{ maxWidth: '100%', margin: '0 auto', overflow: 'hidden' }}>
        <TestimonialsSection
          eyebrow="WHAT FOUNDERS SAY"
          title="Decks That Got the"
          accent="Yes"
          testimonials={testimonials}
        />
      </div>
    </Sec>
  );
};

